var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ShokurekishoJobHistoryCard,{attrs:{"basic-data":_vm.basicData,"current-card-id":_vm.currentCardId,"lead":_setup.careerLead,"show-omonajiseki":false,"variant":"career"}})
}
var staticRenderFns = []

export { render, staticRenderFns }